import {
  Component,
  OnInit,
  Input,
  ViewEncapsulation,
  HostBinding,
} from '@angular/core';
import { styleVariables } from '../../styles/variables';

@Component({
  selector: 'pg-badge-progress-indicator, grit-badge-progress-indicator',
  templateUrl: './pg-badge-progress-indicator.component.html',
  styleUrls: ['./pg-badge-progress-indicator.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class PgBadgeProgressIndicatorComponent implements OnInit {
  @HostBinding('class.pg-badge-progress-indicator')
  _classPgBadgeProgressIndicator = true;

  @Input()
  get progress() {
    return this._progress;
  }
  set progress(value: number) {
    this._progress = Math.max(0, Math.min(100, value));
  }
  protected _progress: number;

  bgDefault = styleVariables.blue200;
  fgDefault = styleVariables.blue500;

  @Input()
  foreground: string;
  @Input()
  background: string;

  constructor() {}

  ngOnInit() {}

  getFillYPosition() {
    return `${100 - this.progress}%`;
  }
}
